import alert from '@/plugins/alert'
import { Book } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    books: {},
    count: 0
  },
  actions: {
    async fetchBooks ({ commit }, options) {
      commit('setBooks', await Book.fetch({ ...options, type: 'book' }))
    },
    async countBooks ({ commit }, options) {
      commit('setCount', await Book.count(options))
    },
    async fetchBook ({ commit }, bookId) {
      commit('setBook', await Book.fetchOne(bookId))
    },
    // api is create or update. If record exist then create.
    async createBook ({ commit }, { data, options }) {
      commit('setBook', await Book.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async updateBook ({ commit, state }, { id, ...book }) {
      commit('setBook', await Book.update(id, book))
      alert.success('Cập nhật thành công!')
    },
    async removeBook ({ commit }, id) {
      await Book.remove(id)
      commit('removeBook', id)
      alert.success('Xóa thành công!')
    },
    setBook ({ commit, state }, book) {
      commit('setBook', book)
    },
    async removeBooks ({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeBook', item.id)
      }
    },
    async updateBooks ({ dispatch }, items) {
      await Promise.all(items.map((item) => dispatch('updateBook', item)))
    }
  },
  mutations: {
    setBooks (state, books) {
      state.books = books.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue
        }),
        {}
      )
    },
    setBook (state, book) {
      state.books = {
        ...state.books,
        [book.id]: book
      }
    },
    removeBook (state, bookId) {
      delete state.books[bookId]
      state.books = { ...state.books }
    },
    setCount (state, count) {
      state.count = count
    }
  },
  getters: {
    books: (state) => {
      return Object.values(state.books)
    },
    book: (state) => (id) => {
      return state.books[id]
    },
    count: (state) => {
      return state.count
    }
  }
}
